import React from 'react'
import BuilderMap from '../BuilderMap/container/BuilderMap'
import { BUILDER_MAP_MODE } from '../BuilderMap/const'
import { SectionTitle, SectionWrapper } from '../../Components/Section'
import LoadingIndicator from '../../Components/LoadingIndicator/LoadingIndicator'

const CityLetterboxBuilder = props =>
  props.cityDataLoaded ? (
    <SectionWrapper className="section-wrapper">
      <SectionTitle>Letterbox Mission Builder</SectionTitle>
      <BuilderMap
        cityId={props.cityId}
        filterByCityIdDistributionZone={props.cityId}
        mode={BUILDER_MAP_MODE.EDIT}
        countryCode={props.countryCode}
        defaultMapPosition={{
          lat: props.cityCenterLocation.latitude,
          lng: props.cityCenterLocation.longitude,
        }}
      />
    </SectionWrapper>
  ) : (
    <LoadingIndicator />
  )

export default CityLetterboxBuilder
